import { __decorate, __metadata } from "tslib";
import { Component, ModelSync, Prop } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
import VueSlider from "vue-slider-component";
export const COMPONENT_NAME = "LvSlider";
let LvSlider = class LvSlider extends UIComponent {
};
__decorate([
    ModelSync("value", "change", { type: [Number, Array], required: false, default: 0 }),
    __metadata("design:type", Object)
], LvSlider.prototype, "model", void 0);
__decorate([
    Prop({ type: Number, required: false, default: 0 }),
    __metadata("design:type", Number)
], LvSlider.prototype, "min", void 0);
__decorate([
    Prop({ type: Number, required: false, default: 100 }),
    __metadata("design:type", Number)
], LvSlider.prototype, "max", void 0);
__decorate([
    Prop({ type: Number, required: false, default: 1 }),
    __metadata("design:type", Number)
], LvSlider.prototype, "interval", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvSlider.prototype, "disabled", void 0);
LvSlider = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: {
            VueSlider,
        },
    })
], LvSlider);
export default LvSlider;
//# sourceMappingURL=script.js.map